<template>
  <div class="report">
    <div v-for=" items in list">
      <div class="title">{{name}}</div>
      <table>
        <tr>
          <th rowspan="2">医疗废物产⽣单位</th>
          <th colspan="2">感染性废物</th>
          <th colspan="2">损伤性废物</th>
          <th rowspan="2">医疗废物产⽣单位</th>
          <th colspan="2">感染性废物</th>
          <th colspan="2">损伤性废物</th>
        </tr>
        <tr>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
        </tr>
        <tr v-for="item in items">
          <td :class="{'l-h':(item[0].length+item[5].length)>52}">{{item[0]}}</td>
          <td>{{item[1]}}</td>
          <td>{{item[2]}}</td>
          <td>{{item[3]}}</td>
          <td>{{item[4]}}</td>
          <td :class="{'l-h':(item[0].length+item[5].length)>52}">{{item[5]}}</td>
          <td>{{item[6]}}</td>
          <td>{{item[7]}}</td>
          <td>{{item[8]}}</td>
          <td>{{item[9]}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
  import Config from "../config.js"
  export default {
    name: "Month",
    data(){
      return {
        name:"医疗废物产⽣处置⽉报表",
        a:true,
        list:[]
      }
    },
    methods:{
      init(){
        this.request(Config.HTTP+"upload?key="+this.$route.query.key,(res)=>{
          this.list=res.list;
          this.name=res.name;
        } )
      },

    },
    mounted(){
    // setTimeout(this.init,500)

    },
    created(){
      this.init()
    }
  }

</script>
<style scoped>
  .report{
  width: 100%;color: #000;}
  .report .title{height:35px;line-height: 35px;font-weight: bold;font-size: 14px;}
  table{
    border-collapse: collapse;
    width: 100%;
  }
  table td{border: 1px solid #000;font-size: 10px;height: 22px;}
  table th{border: 1px solid #000;font-size: 10px;height:22px;}
  .l-h{line-height: 17px !important;font-size: 10px !important;}
</style>



// WEBPACK FOOTER //
// src/view/report/month.vue